import React from "react";

const formatDate = (value) =>
  value
    ? new Date(value).toLocaleString("default", {
      day: "numeric",
      month: "long",
      year: "numeric",
    })
    : "—";

function MilkPreview(props) {
  // The parent already fetched the period along with its computed totals,
  // so there is nothing to load here.
  const milk = props.milk || {};

  function handleClick() {
    props.setSelectedMilk(props.milkID);
    props.setisUpdateModalOpen(true);
  }

  return (
    <div
      className={"tems-center flex justify-start cursor-pointer flex-row transition-all duration-200 hover:translate-x-2 " +
        (props.index === props.listLength - 1 ? "" : "border-b dark:border-slate-700 border-stone-200")}
      onClick={() => handleClick()}
    >
      <div className="my-3 ml-3 md:my-5 w-6 ">
        <div className="dark:text-white">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" >
            <path d="M8 2h8" />
            <path d="M9 2v2.789a4 4 0 0 1-.672 2.219l-.656.984A4 4 0 0 0 7 10.212V20a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-9.789a4 4 0 0 0-.672-2.219l-.656-.984A4 4 0 0 1 15 4.788V2" />
            <path d="M7 15a6.472 6.472 0 0 1 5 0 6.47 6.47 0 0 0 5 0" />
          </svg></div>
      </div>

      <div className="w-24 md:w-36 text-right flex flex-col items-end justify-center text-sm md:text-base">
        <span className="ml-3 font-medium dark:text-white tabular-nums text-nowrap">{milk.periodQuantity} kg</span>
        <span className="ml-3 text-xs text-stone-400 dark:text-slate-400 tabular-nums text-nowrap">
          {milk.quantity} kg/j × {milk.days} j
        </span>
      </div>
      <div className="w-28 md:w-40 flex justify-center items-center text-right text-xs md:text-base">
        {milk.adLibitum && <span className="ml-3 h-fit font-medium text-nowrap dark:text-white rounded-full bg-stone-100 dark:bg-slate-800 dark:border-slate-700 text-stone-600 px-2 py-1 border border-stone-300">Ad libitum</span>
        }</div>
      <div className="flex w-56 md:w-full flex-row items-center justify-end">
        <div className="flex flex-col md:flex-row items-end justify-end w-full mr-3">
          <span className="md:mr-3 text-sm text-stone-400 dark:text-slate-400">
            {formatDate(milk.startDate)}</span>
          <span className="text-sm mr-1 text-stone-400 dark:text-slate-400 hidden md:block"> - </span>
          <span className="text-sm text-stone-400 dark:text-slate-400">{formatDate(milk.endDate)}
          </span></div>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth={1.5}
          stroke="currentColor"
          className="mr-1 h-4 w-4 text-stone-600 dark:text-slate-400"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M8.25 4.5l7.5 7.5-7.5 7.5"
          />
        </svg>
      </div>
    </div>
  );
}

export default MilkPreview;
